module.exports = __webpack_public_path__ + "img/chat_p.89f299ee.svg";